export default __webpack_public_path__ + "../staticImages/winefinder-sprite-occasion_party-2x.png";